import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { sessionApi } from '../api/session-api';
import { useSessionStore } from './session-store';

export const sessionKeys = {
  all: ['session'] as const,
  me: () => [...sessionKeys.all, 'me'] as const,
};

export function useCurrentUserQuery() {
  const status = useSessionStore((s) => s.status);
  const setUser = useSessionStore((s) => s.setUser);
  const query = useQuery({
    queryKey: sessionKeys.me(),
    queryFn: () => sessionApi.me(),
    enabled: status === 'authenticated',
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (query.data) setUser(query.data);
  }, [query.data, setUser]);

  return query;
}
